<template>
  <div class="main-listcj">
    <LoginTrigger></LoginTrigger>
    <section class="products">
      <div class="breadcumb">
        <router-link to="/" class="anchor-home">Inicio</router-link>
        <span class="arrow-bread">></span>
        <span class="anchor-compare">Comparativa</span>
      </div>
      <div class="direct-access-content">
        <h4>¿Listo para hacer una comparativa?</h4>
        <p class="direct-access-placeholder">
          Selecciona un producto para empezar con la comparativa
        </p>
      </div>
      <div class="products-wrapper row">
        <div v-for="item in data" :key="item.title">
          <CardProduct
            :src="item.src"
            :href="item.href"
            :title="item.title"
            :h2="item.h2"
          ></CardProduct>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CardProduct from "../components/CardProduct.vue";
import LoginTrigger from "../components/LoginTrigger.vue";
import dataList from "./../_helpers/data/datalist.json";


export default {
  components: {
    CardProduct,
    LoginTrigger,
  },
  data() {
    return {
      data: [],
      user: [],
    };
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    let datos = JSON.parse(JSON.stringify(dataList));
    for (const key in datos) {
      if (Object.hasOwnProperty.call(datos, key)) {
        const element = datos[key];
        const concat = (element.href.indexOf('?') < 0) ? '?' : '&';
        element.href = element.href + concat + 'utm_source=' + this.user.source + '&utm_medium=' + this.user.id_shop + '&utm_campaign=' + this.user.id_user
      }
    }
    this.data = datos
  },
};
</script>

<style lang="scss">
@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/mixins/mixins";
@import "../../core/core-framework/assets/scss/inc/_buttons";
@import "../../core/core-framework/assets/scss/inc/_shadows.scss";
.row {
  display: flex;
  flex-wrap: wrap;
}
.products {
    padding: 1px 72px 49px;
    @media screen and (min-width: 1900px) {
    padding: 1px 347px 49px;  
}
}
.direct-access-content {
  padding: 33px 0px 76px;

  h4 {
    @include text(
      $size: 23px,
      $color: $color-blue-02,
      $lineheight: 22px,
      $weight: 600
    );
    margin-bottom: 15px;
    text-align: left;
    cursor: default;
  }

  .direct-access-placeholder {
    @include text($size: 16px, $color: $color-grey-03, $lineheight: 1.47);
    margin-bottom: -9px;
    position: relative;
    cursor: default;

    &::after {
      right: 16px;
      width: calc(100% + -13px);
      height: 1px;
      position: absolute;
      content: "";
      background: $color-grey-04;
      top: 29px;
    }
  }
}
.breadcumb {
  font-size: 12px;
  line-height: 1.5;
  color: $color-black;
  
  .anchor-home {
    &:visited {
      color: $color-black;
    }
  }
  .anchor-compare {
    color: $color-blue-02;
    font-weight: 900;
    text-decoration: underline;
  }
  .arrow-bread {
    color: $color-blue-02;
    font-weight: 900;
    margin: 0 8px;
    }
}
@media screen and(min-width: 768px) {
  .btn.solid-main.small {
  border-radius: 0 0 8px 8px;
  padding: 13px 25px;
  font-size: 15px;
}
}

</style>
